import { render, staticRenderFns } from "./MultiAssetCell.vue?vue&type=template&id=2655c1f2&scoped=true"
import script from "./MultiAssetCell.vue?vue&type=script&lang=js"
export * from "./MultiAssetCell.vue?vue&type=script&lang=js"
import style0 from "./MultiAssetCell.vue?vue&type=style&index=0&id=2655c1f2&prod&scoped=true&lang=scss"
import style1 from "./MultiAssetCell.vue?vue&type=style&index=1&id=2655c1f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655c1f2",
  null
  
)

export default component.exports